import BigNumber from 'bignumber.js';

export default function formatPercentage(num: BigNumber.Value, decimalNumber = 2, roundingMode?: BigNumber.RoundingMode) {
  return new BigNumber(num).multipliedBy(100).decimalPlaces(decimalNumber, roundingMode).toFixed();
}
